module.exports = __webpack_public_path__ + "img/food-basics.d8e2d763.svg";